import { useState, useEffect, useRef } from 'react'
import { NoRecords } from '../../lib/loader'
import {
    Table, TableBody, TableCell, TableHead, TableRow, Button, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip, Chip
} from '@mui/material';

import moment from 'moment';
import { useUserHistory, useSupdateBlockstatus, useUpdateUserAccess, useExportUserList, useLoginAsUser } from './UserDetailapi';
import { Search, Eye, Copy, Check, UserRoundPen, Download, UserCog, Clock, ArrowUp, ArrowDown } from 'lucide-react';
import { useDebounce } from '../../hooks/debounce';
import { useParams, useNavigate } from 'react-router-dom';
import { queryClient } from "../../config";
import { copyToClipboard } from '../../lib/copytoClipboard';
import { useModalContext } from '../../contexts/ModalContext';
import { useToast } from '../../hooks/usetoast';
import { useCheckAdminAccess } from '../WhiteIp/api/whiteipapi';
import { logout } from '../../hooks/logout';
import PermissionDenied from '../common/permissionDenied';
import { Modal, ModalBody } from 'reactstrap';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import user from '../../assets/images/icons/user.svg';
import { Controller, useForm } from 'react-hook-form';
import { useBreadcrumbPagination } from '../../hooks/useBreadcrumbPagination';
import BreadcrumbPagination from '../../utils/BreadcrumbPagination';
import { WaitingLoader } from '../../hooks/buttonLoad';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import Filter from './Filter';

const schema = yup.object().shape({
    status: yup.boolean(),
});

const allOptions = [
    { module: "Internal Transfer" },
    { module: "Deposit" },
    { module: "Withdraw" },
    { module: "Virtual Cards" },
    { module: "Card Topup" },
];


function UserHistory() {

    const { handleSubmit, control, setValue } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
    });
    const [loading, setLoading] = useState(false);
    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(25);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [country, setCountry] = useState('');
    const [kycStatus, setKycStatus] = useState('');
    const [cardStatus, setCardStatus] = useState('');
    const [sortOrder, setSortOrder] = useState('desc');

    const [recentLogin, setRecentLogin] = useState("All");
    const [recentLoginFilter, setRecentLoginFilter] = useState(false);





    const [search, setSearch] = useState("");
    const searchText = useDebounce(search);
    const { id } = useParams();
    const navigate = useNavigate()
    const { theme } = useModalContext()
    const toast = useToast();
    const [userEmail, setUserEmail] = useState(false);
    const [open, setOpen] = useState(false);
    const toggle = () => setOpen(!open);
    const { data: getAllUserList } = useExportUserList()
    const inputRef = useRef(null);


    const userLoginMutation = useLoginAsUser();

    const { data: getUserHistory, isLoading } = useUserHistory({
        id,
        page: searchText ? 0 : tempPage,
        size: tempRows,
        searchText,
        sortField: "createdAt",
        sortOrder: sortOrder,
        country: country ? country.split(' ')[0] : '',
        recentLogin: recentLogin,
        kycStatus: kycStatus,
        cardStatus
    })

    const totalRecords = getUserHistory?.data?.totalRecords || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            const length = inputRef.current.value.length;
            inputRef.current.setSelectionRange(length, length);
        }
    });

    useEffect(() => {
        setTempPage(0);
        if (handleChangePage) {
            handleChangePage(null, 0);
        }
    }, [searchText]);



    const handleUser = (row) => {
        navigate(`/SingleUserHistory/${row._id}`);
        localStorage.setItem("_id", row._id)
    };

    const updateBlockstatus = useSupdateBlockstatus()


    const userStatus = async (item, updateField) => {
        let obj = {
            userId: item._id,
            status: updateField,
        };
        const updateStatus = await updateBlockstatus.mutateAsync({ ...obj });
        if (updateStatus?.message === "Status blocked successfully") {
            queryClient?.refetchQueries(["user-history", item._id]);
        }
    };

    const copyUserEmailAddress = async data => {
        setUserEmail(data._id)
        await copyToClipboard(data?.email)
        toast.success("Email Address copied")
        setTimeout(() => {
            setUserEmail()
        }, 800)
    }


    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);

    useEffect(() => {
        checkAdminAccess();
    }, []);



    const checkAdminAccess = async () => {
        try {
            const obj = { page: "User Management" };
            const checkAdminRes = await checkAdminMutation.mutateAsync(obj);
            if (!checkAdminRes?.data?.status) {
                setAccess(false);
                logout();
            } else {
                setAccess(true);
            }
        } catch (error) {
            setAccess(false);
        }
    };

    const [singleview, setSingleview] = useState('');
    const [selectedOptions, setSelectedOptions] = useState([]);
    const updatePermission = useUpdateUserAccess();

    const Edit = async (item) => {
        setSingleview(item);
        setSelectedOptions(item?.permission || []);
        setValue('permission', item?.permission || []);
        toggle();
    };

    const handleOptionChange = (option, checked) => {
        setSelectedOptions((prevSelectedOptions) => {
            let updatedSelectedOptions = [...prevSelectedOptions];
            const existingOptionIndex = updatedSelectedOptions.findIndex(
                (item) => item.title === option.module
            );

            if (existingOptionIndex !== -1) {
                if (!checked) {
                    updatedSelectedOptions.splice(existingOptionIndex, 1);
                }
            } else if (checked) {
                updatedSelectedOptions.push({
                    title: option.module,
                    status: checked,
                });
            }

            setValue('permission', updatedSelectedOptions);
            if (updatedSelectedOptions.length > 0) {
                setValue('permission', updatedSelectedOptions, { shouldValidate: true });
            }
            return updatedSelectedOptions;
        });
    };

    const arraysAreEqual = (arr1, arr2) => {
        if (!arr1 || !arr2 || arr1.length !== arr2.length) return false;
        return arr1.every((item, index) =>
            item.title === arr2[index].title &&
            item.icon === arr2[index].icon &&
            item.link === arr2[index].link &&
            item.status === arr2[index].status
        );
    };

    const onSubmit = async (data) => {

        setLoading(true)
        const permissionsChanged = !arraysAreEqual(singleview?.permission, selectedOptions);

        if (permissionsChanged) {
            const obj = {
                _id: singleview?._id,
                permission: selectedOptions,
            };
            const res = await updatePermission.mutateAsync(obj);
            if (res.status) {
                toast.success("Status updated");
                queryClient.refetchQueries('user-history');
                setLoading(false)
                setOpen(false);
            } else {
                toast.error(res.message);
                setLoading(false)
                setOpen(false);
            }
        } else {
            toast.error("No changes done");
            setLoading(false)
            setOpen(false)
        }
    };



    const exportAllUsers = async () => {
        try {
            const response = await getAllUserList?.data;

            const allUsers = response?.usersHistory || [];
            await exportToExcel(allUsers, 'UserList.xlsx');
        } catch (error) {
            console.error('Export failed:', error);
        }
    };

    const exportToExcel = async (data, filename) => {
        if (!data || data.length === 0) return;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Users');

        worksheet.columns = [
            { header: 'UserName', key: 'UserName', width: 20 },
            { header: 'Email', key: 'Email', width: 30 },
            { header: 'Type', key: 'Type', width: 15 },
            { header: 'EmailVerified', key: 'EmailVerified', width: 15 },
            { header: 'MobileVerified', key: 'MobileVerified', width: 15 },
            { header: 'UserID', key: 'UserID', width: 25 },
            { header: 'KYCStatus', key: 'KYCStatus', width: 15 },
            { header: 'KYCVerified', key: 'KYCVerified', width: 15 },
            { header: 'Blocked', key: 'Blocked', width: 10 },
            { header: 'AccountStatus', key: 'AccountStatus', width: 20 },
            { header: 'CreatedAt', key: 'CreatedAt', width: 25 },
        ];

        worksheet.getRow(1).eachCell(cell => {
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF4F81BD' } };
            cell.alignment = { horizontal: 'center' };
        });

        data.forEach(item => {
            worksheet.addRow({
                UserName: item.userName,
                Email: item.email,
                Type: item.type,
                EmailVerified: item.isEmailVerified,
                MobileVerified: item.isMobileVerified,
                UserID: item.userId,
                KYCStatus: item.isKycStatus,
                KYCVerified: item.isKycVerified,
                Blocked: item.isBlocked,
                AccountStatus: item.accountDeletionStatus,
                CreatedAt: new Date(item.createdAt).toLocaleString(),
            });
        });

        worksheet.columns.forEach(column => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, cell => {
                const length = cell.value ? String(cell.value).length : 10;
                if (length > maxLength) maxLength = length;
            });
            column.width = Math.min(maxLength + 2, 50);
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        saveAs(blob, filename);
    };

    const openLoginDialog = (user) => {
        setSelectedUser(user);
        setDialogOpen(true);
    };

    const confirmLoginAsUser = async () => {
        setLoading(true)
        try {
            const resp = await userLoginMutation.mutateAsync({
                id: selectedUser?._id
            })
            if (!resp?.status) {
                toast.error(resp?.data?.message);
                setLoading(false)

            } else {
                toast.success(resp?.data?.message)

                window.open(`https://roupay.io/adminLogin/${resp?.data?.token}`, '_blank');
            }

        } catch (error) {
            console.error("Error login as user:", error);
        } finally {
            setDialogOpen(false);
            setLoading(false)
        }
    }



    const renderKycStatusChip = (status) => {
        if (!status) {
            return (
                <Chip
                    label="Not Yet Started"
                    size="small"
                    sx={{
                        backgroundColor: '#FFF3CD',
                        color: '#856404',
                        fontWeight: 'bold',
                        borderRadius: '8px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                        border: '1px solid #FFEAA7',
                    }}
                />
            );
        }

        if (['approved', 'Approved'].includes(status)) {
            return (
                <Chip
                    label="Approved"
                    size="small"
                    sx={{
                        backgroundColor: '#D4EDDA',
                        color: '#155724',
                        fontWeight: 'bold',
                        borderRadius: '8px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                        border: '1px solid #C3E6CB',
                    }}
                />
            );
        }

        if (status !== 'approved' || "Approved") {
            return (
                <Chip
                    label={status ? status.charAt(0).toUpperCase() + status.slice(1) : "Denied"}
                    size="small"
                    sx={{
                        backgroundColor: '#F8D7DA',
                        color: '#721C24',
                        fontWeight: 'bold',
                        borderRadius: '8px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                        border: '1px solid #F5C6CB',
                    }}
                />
            );
        }

        return (
            <Chip
                label={status}
                size="small"
                sx={{
                    backgroundColor: '#E2E3E5',
                    color: '#383D41',
                    fontWeight: 'bold',
                    borderRadius: '8px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                    border: '1px solid #D6D8DB',
                }}
            />
        );
    };


    const renderUserHistoryTable = () => (
        getUserHistory?.data?.usersHistory?.length > 0 ? (
            <>
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="user history table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">S.NO</TableCell>
                                    <TableCell align="center">Login Type</TableCell>
                                    <TableCell align="center">User Name</TableCell>
                                    <TableCell align="center">Email</TableCell>
                                    <TableCell align="center">Email Verified</TableCell>
                                    <TableCell align="center">KYC status</TableCell>
                                    <TableCell align="center">Card status</TableCell>

                                    <TableCell >Blocked</TableCell>
                                    <TableCell align="center">Date and Time {sortOrder !== "desc" ? <ArrowUp onClick={() => setSortOrder('desc')} style={{ cursor: "pointer" }} /> : <ArrowDown onClick={() => setSortOrder('asc')} style={{ cursor: "pointer" }} />}</TableCell>

                                    <TableCell align="center">Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getUserHistory?.data?.usersHistory?.map((row, i) => (
                                    <TableRow key={row._id || i}>
                                        <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell align="center">{row?.type?.toUpperCase() || "-"}</TableCell>
                                        <TableCell align="center">{row?.userName || "-"}</TableCell>
                                        <TableCell align="center">
                                            {row?.email || "-"}
                                            {row?.email && userEmail !== row._id && (
                                                <Copy
                                                    onClick={() => copyUserEmailAddress(row)}
                                                    size={20}
                                                    className='ml-5'
                                                    style={{
                                                        cursor: "pointer",
                                                        marginLeft: "5px",
                                                        color: theme ? "white" : "black"
                                                    }}
                                                />
                                            )}
                                            {row?.email && userEmail === row._id && (
                                                <Check
                                                    size={20}
                                                    style={{
                                                        marginLeft: "5px",
                                                        color: theme ? "white" : "black"
                                                    }}
                                                />
                                            )}
                                        </TableCell>

                                        <TableCell align="center">{row?.isEmailVerified ? "Yes" : "No"}</TableCell>

                                        <TableCell align="center">
                                            {row?.kycReason ? (
                                                <Tooltip title={row.kycReason} arrow>
                                                    <span>
                                                        {renderKycStatusChip(row?.kycStatus)}
                                                    </span>
                                                </Tooltip>
                                            ) : (
                                                renderKycStatusChip(row?.kycStatus)
                                            )}
                                        </TableCell>
                                        <TableCell align="center">
                                            <div className="pulse-container">
                                                <div className={`circle ${row?.isActiveCard == "Active" ? "circle-active" : "circle-inactive"}  `}></div>
                                                <span>{row?.isActiveCard == "Active" ? "Active" : "In Active"}</span>
                                            </div>
                                        </TableCell>


                                        <TableCell align="center">
                                            <div className="form-check form-switch">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    role="switch"
                                                    id={`flexSwitchCheckDefault-${row._id}`}
                                                    checked={row?.isBlocked}
                                                    onChange={() => userStatus(row, !row?.isBlocked)}
                                                />
                                            </div>
                                        </TableCell>

                                        <TableCell align="center">
                                            {moment(row?.createdAt).format("DD-MM-YYYY | hh:mm A")}
                                        </TableCell>


                                        <TableCell align="center">
                                            <Tooltip title="View User Details" arrow>
                                                <Eye
                                                    className="mx-3"
                                                    size={20}
                                                    type="button"
                                                    onClick={() => handleUser(row)}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                            </Tooltip>

                                            <Tooltip title="Login as user" arrow>
                                                <UserCog
                                                    size={20}
                                                    type="button"
                                                    onClick={() => openLoginDialog(row)}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                            </Tooltip>

                                            <Tooltip title="Edit user access" arrow>
                                                <UserRoundPen
                                                    className="mx-3"
                                                    size={20}
                                                    onClick={() => Edit(row)}
                                                    type="button"
                                                    style={{ cursor: 'pointer' }}
                                                />
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />

                <Modal isOpen={open} toggle={toggle} centered>
                    <div className="modal-header">
                        <h1 className="modal-title fs-5"> Update Accessibility</h1>
                        <button type="button" className="btn-close" onClick={toggle} aria-label="Close">
                            <img src={require('../../assets/images/icons/close-circle.svg').default} alt="close-circle" />
                        </button>
                    </div>
                    <ModalBody>
                        <form onSubmit={handleSubmit(onSubmit)} noValidate>
                            <div className="col-sm-12 col-md-8 col-lg-8">
                                <div className="input-group mb-3">
                                    <span className="input-group-icon">
                                        <img src={user} className='img-fluid' alt="User" />
                                    </span>
                                    <Controller
                                        name='name'
                                        control={control}
                                        render={({ field }) => (
                                            <input
                                                {...field}
                                                defaultValue={singleview?.userName}
                                                className="form-control"
                                                autoComplete='off'
                                                readOnly
                                            />
                                        )}
                                    />
                                </div>
                                <div className="input-group mb-3">
                                    <span className="input-group-icon">
                                        <img src={user} className='img-fluid' alt="User" />
                                    </span>
                                    <Controller name='email' control={control} render={({ field }) => (
                                        <input
                                            {...field}
                                            className="form-control"
                                            autoComplete='off'
                                            readOnly
                                            defaultValue={singleview?.email}
                                        />
                                    )} />
                                </div>
                                <fieldset style={{ border: 'none', padding: 0, margin: 0 }}>
                                    <legend style={{ fontWeight: "bolder", marginTop: "4px" }}>Modules:</legend>
                                    <div className='mt-3'>
                                        {allOptions.map((option) => {
                                            const isChecked = selectedOptions.some(
                                                (perm) => perm.title === option.module
                                            );

                                            return (
                                                <div key={option.module} className='mb-8 d-flex align-items-center'>
                                                    <input
                                                        type="checkbox"
                                                        id={`module-${option.module}`}
                                                        name={option.module}
                                                        checked={!!isChecked}
                                                        onChange={(e) => handleOptionChange(option, e.target.checked)}
                                                        style={{ marginRight: '10px' }}
                                                    />
                                                    <label htmlFor={`module-${option.module}`} style={{ fontWeight: 'bold' }}>
                                                        {option.module}
                                                    </label>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </fieldset>


                            </div>
                            <div className="d-grid crPgbtn pt-3">
                                <button type="submit" className="btn btn-primary">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </ModalBody>
                </Modal>
                <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                    <DialogTitle>Confirm Login</DialogTitle>
                    <DialogContent>
                        Are you sure you want to login as user <strong>{selectedUser?.userName}</strong>?
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setDialogOpen(false)} color="secondary">Cancel</Button>
                        <Button onClick={() => confirmLoginAsUser()} color="primary">Confirm</Button>
                    </DialogActions>
                </Dialog>

            </>
        ) : (
            <NoRecords />
        )
    );


    return (
        <>
            {loading && <WaitingLoader />}
            {isLoading ? (
                <WaitingLoader />
            ) : access ? (
                <section>
                    <div className=' d-flex justify-content-between'>
                        <h4 className='d-flex align-items-center'>User History</h4>


                        <div className=' d-flex align-items-center '>
                            {
                                country &&
                                <Chip
                                    label={country || "All Countries"}
                                    onDelete={() => setCountry("")}
                                    variant="outlined"
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: '14px',
                                        marginRight: "8px",
                                        px: 2.5,
                                        py: 1.3,
                                        cursor: 'pointer',
                                        borderRadius: '14px',
                                        backgroundColor: '#fff',
                                        color: country ? '#333' : '#777',
                                        borderColor: country ? '#e0e0e0' : '#f0f0f0',
                                        boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
                                        '&:hover': {
                                            transform: 'translateY(-2px) scale(1.02)',
                                            boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
                                            backgroundColor: '#fafafa',
                                            borderColor: country ? '#ccc' : '#e0e0e0',
                                        },
                                        '&:active': {
                                            transform: 'translateY(0) scale(0.98)',
                                            boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
                                        },
                                        '& .MuiChip-deleteIcon': {
                                            color: '#9e9e9e',
                                            marginInlineStart: '6px',
                                            transition: 'all 0.2s ease-in-out',
                                            borderRadius: '50%',
                                            padding: '2px',
                                            '&:hover': {
                                                color: '#d32f2f !important',
                                                backgroundColor: 'rgba(211,47,47,0.08)',
                                                transform: 'scale(1.2)',
                                            },
                                            '&:active': {
                                                transform: 'scale(0.9)',
                                            },
                                        },
                                        transition: 'all 0.3s cubic-bezier(0.33, 1, 0.68, 1)',
                                    }}
                                />

                            }
                            {
                                kycStatus &&
                                <Chip
                                    label={kycStatus || "All Countries"}
                                    onDelete={() => setKycStatus("")}
                                    variant="outlined"
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: '14px',
                                        marginRight: "8px",
                                        px: 2.5,
                                        py: 1.3,
                                        cursor: 'pointer',
                                        borderRadius: '14px',
                                        backgroundColor: '#fff',
                                        color: kycStatus ? '#333' : '#777',
                                        borderColor: kycStatus ? '#e0e0e0' : '#f0f0f0',
                                        boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
                                        '&:hover': {
                                            transform: 'translateY(-2px) scale(1.02)',
                                            boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
                                            backgroundColor: '#fafafa',
                                            borderColor: kycStatus ? '#ccc' : '#e0e0e0',
                                        },
                                        '&:active': {
                                            transform: 'translateY(0) scale(0.98)',
                                            boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
                                        },
                                        '& .MuiChip-deleteIcon': {
                                            color: '#9e9e9e',
                                            marginInlineStart: '6px',
                                            transition: 'all 0.2s ease-in-out',
                                            borderRadius: '50%',
                                            padding: '2px',
                                            '&:hover': {
                                                color: '#d32f2f !important',
                                                backgroundColor: 'rgba(211,47,47,0.08)',
                                                transform: 'scale(1.2)',
                                            },
                                            '&:active': {
                                                transform: 'scale(0.9)',
                                            },
                                        },
                                        transition: 'all 0.3s cubic-bezier(0.33, 1, 0.68, 1)',
                                    }}
                                />

                            }
                            {
                                cardStatus &&
                                <Chip
                                    label={cardStatus || "All Countries"}
                                    onDelete={() => setCardStatus("")}
                                    variant="outlined"
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: '14px',
                                        marginRight: "8px",
                                        px: 2.5,
                                        py: 1.3,
                                        cursor: 'pointer',
                                        borderRadius: '14px',
                                        backgroundColor: '#fff',
                                        color: cardStatus ? '#333' : '#777',
                                        borderColor: cardStatus ? '#e0e0e0' : '#f0f0f0',
                                        boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
                                        '&:hover': {
                                            transform: 'translateY(-2px) scale(1.02)',
                                            boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
                                            backgroundColor: '#fafafa',
                                            borderColor: cardStatus ? '#ccc' : '#e0e0e0',
                                        },
                                        '&:active': {
                                            transform: 'translateY(0) scale(0.98)',
                                            boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
                                        },
                                        '& .MuiChip-deleteIcon': {
                                            color: '#9e9e9e',
                                            marginInlineStart: '6px',
                                            transition: 'all 0.2s ease-in-out',
                                            borderRadius: '50%',
                                            padding: '2px',
                                            '&:hover': {
                                                color: '#d32f2f !important',
                                                backgroundColor: 'rgba(211,47,47,0.08)',
                                                transform: 'scale(1.2)',
                                            },
                                            '&:active': {
                                                transform: 'scale(0.9)',
                                            },
                                        },
                                        transition: 'all 0.3s cubic-bezier(0.33, 1, 0.68, 1)',
                                    }}
                                />


                            }



                            <Chip
                                label={"Recently Login"}

                                icon={
                                    recentLoginFilter
                                        ? <Check size={16} color="#fff" style={{ strokeWidth: 3 }} />
                                        : <Clock size={16} color="#666" />
                                }
                                onClick={() => {
                                    setRecentLoginFilter(!recentLoginFilter);
                                    recentLogin === "All" ? setRecentLogin("recentLogin") : setRecentLogin("All");
                                }}
                                sx={{
                                    fontWeight: 600,
                                    fontSize: '14px',
                                    px: 1.5,
                                    py: 2.5,
                                    borderRadius: '12px',
                                    cursor: 'pointer',
                                    transition: 'all 0.35s cubic-bezier(0.2, 0.8, 0.2, 1)',

                                    backgroundColor: recentLoginFilter ? '#000' : '#fff',
                                    color: recentLoginFilter ? '#fff' : '#444',
                                    border: recentLoginFilter ? '1px solid #000' : '1px solid #e0e0e0',


                                    boxShadow: recentLoginFilter
                                        ? '0 8px 24px rgba(0,0,0,0.35)'
                                        : '0 1px 2px rgba(0,0,0,0.05)',

                                    '&:hover': {
                                        backgroundColor: recentLoginFilter ? '#1a1a1a' : '#fafafa',
                                        borderColor: recentLoginFilter ? '#000' : '#d0d0d0',
                                        transform: 'translateY(-2px)',
                                        boxShadow: recentLoginFilter
                                            ? '0 12px 32px rgba(0,0,0,0.45)'
                                            : '0 4px 12px rgba(0,0,0,0.08)',
                                    },

                                    '&:active': {
                                        transform: 'scale(0.98) translateY(0)',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                    },

                                    '& .MuiChip-icon': {
                                        marginRight: '8px',
                                        marginLeft: '4px',
                                        transition: 'all 0.3s ease',
                                        transform: recentLoginFilter ? 'scale(1)' : 'scale(0.9)',
                                        opacity: recentLoginFilter ? 1 : 0.7,
                                    },

                                    '& .MuiChip-label': {
                                        paddingLeft: '4px',
                                        paddingRight: '4px',
                                        letterSpacing: '0.3px',
                                    }
                                }}
                            />


                            <Filter country={country} setCountry={setCountry} kycStatus={kycStatus} setKycStatus={setKycStatus} cardStatus={cardStatus} setCardStatus={setCardStatus} />
                        </div>

                    </div>
                    <div className="ad_pg_bx bg-white p-3">
                        <div
                            className="d-flex justify-content-between align-items-center mb-2"
                            style={{ flexWrap: 'wrap' }}
                        >
                            <div className="d-flex align-items-center" style={{ gap: '5px' }}>
                                <div className="input-group" style={{ width: '400px' }}>
                                    <span className="input-group-icon">
                                        <Search size={20} color="#aaa9a9" />
                                    </span>
                                    <input
                                        type="text"
                                        ref={inputRef}
                                        onChange={(e) => setSearch(e.target.value)}
                                        className="form-control"
                                        placeholder="Search by name , email ,phone number"
                                        value={search}
                                        style={{ width: '200px' }}
                                    />
                                </div>
                            </div>

                            <button
                                className="btn btn-success"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    whiteSpace: 'nowrap',
                                }}
                                onClick={() => exportAllUsers()}
                            >
                                <Download size={15} style={{ marginRight: '5px' }} />
                                Export
                            </button>

                        </div>
                        {renderUserHistoryTable()}
                    </div>
                </section>
            ) : (
                <PermissionDenied />
            )}


        </>
    )
}




export default UserHistory















